/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AbstractControl } from '@angular/forms'
import moment from 'moment/min/moment-with-locales'

export const maxDate = (date: string, format: string) => {
  return (control: AbstractControl) => {
    if (!control.value) return null

    const controlDate = moment(control.value, format, true)
    const maxDateMoment = moment(date, format, true)
    // If the control value is not a valid date, treat it as a validation error
    if (!controlDate.isValid()) {
      return { maxDate: true }
    }
    // If the configured max date is invalid, log a warning and do not block the value.
    if (!maxDateMoment.isValid()) {
      console.warn('[maxDate validator] Invalid max date configuration', { date, format })
      return null
    }
    if (controlDate.isSameOrAfter(maxDateMoment)) {
      return { maxDate: true }
    }
    return null
  }
}
